import {
  LeaderboardDetails,
  LeaderboardHistoryItem,
  LeaderboardState,
} from '$store/leaderboard/interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoadingStatus } from '$store/reels/interface';
import { RootState } from '$store/rootReducer';
import { CurrencyEnum } from '$store/models';

const initialState: LeaderboardState = {
  id: 0,
  title: '',
  wikiLink: '',
  date: 0,
  startAt: 0,
  endAt: 0,
  myRank: 0,
  prizes: {},
  currency: CurrencyEnum.EUR,
  memberIds: [],
  loadingStatus: 'loading',

  history: [],
  historyLoadingStatus: 'loading',
  type: undefined,

  details: null,
  detailsLoadingStatus: 'loading',
};

export const { actions, reducer } = createSlice({
  name: 'leaderboard',
  initialState,
  reducers: {
    load(state, __: PayloadAction<{ main?: boolean } | undefined>) {
      state.loadingStatus = 'loading';
    },
    setSuccessData(
      state,
      action: PayloadAction<{
        id: number;
        title: string;
        wikiLink: string;
        date: number;
        startAt: number;
        endAt: number;
        myRank: number;
        prizes: { [index: number]: number };
        currency?: string;
        memberIds: number[];
        type?: string;
      }>,
    ) {
      state.id = action.payload.id;
      state.title = action.payload.title;
      state.wikiLink = action.payload.wikiLink;
      state.date = action.payload.date;
      state.startAt = action.payload.startAt;
      state.endAt = action.payload.endAt;
      state.myRank = action.payload.myRank;
      state.prizes = action.payload.prizes;
      state.currency = action.payload.currency ?? CurrencyEnum.EUR;
      state.memberIds = action.payload.memberIds;
      state.type = action.payload.type as any;
    },
    setLoadingStatus(state, action: PayloadAction<LoadingStatus>) {
      state.loadingStatus = action.payload;
    },
    setMyRank(state, action: PayloadAction<number>) {
      state.myRank = action.payload;
    },
    join(state, __: PayloadAction<number>) {},

    loadHistory(state) {
      state.historyLoadingStatus = 'loading';
    },
    setHistory(state, action: PayloadAction<LeaderboardHistoryItem[]>) {
      state.history = action.payload;
    },
    setHistoryLoadingStatus(state, action: PayloadAction<LoadingStatus>) {
      state.historyLoadingStatus = action.payload;
    },

    loadDetails(state, __: PayloadAction<number>) {
      state.detailsLoadingStatus = 'loading';
    },
    setDetails(state, action: PayloadAction<LeaderboardDetails>) {
      state.details = action.payload;
    },
    setDetailsLoadingStatus(state, action: PayloadAction<LoadingStatus>) {
      state.detailsLoadingStatus = action.payload;
    },
  },
});

export { reducer as leaderboardReducer, actions as leaderboardActions };

export const selectLeaderboard = (state: RootState): ReturnType<typeof reducer> =>
  state.leaderboard;
